<template>
  <div class="tags" @mouseover="scrollss()">
    <div class="tag" 
      v-for="(category, index) in list"
      :class="{'selected' : selectedMainCategories.indexOf(category.Name) != -1 
      || selectedSubCategories.indexOf(category.Name) != -1
      || selectedRecipeCategories.indexOf(category.Name) != -1}"
      :key="index">
        {{category.Name || category}}
      </div>
  </div>
</template>

<script>
export default {
  props: ['list'],
  methods: {
    scrollss(){
      console.log()
    }
  },
  computed: {
    selectedMainCategories(){
      return this.$store.getters.selectedMainCategories
    },
    selectedSubCategories(){
      return this.$store.getters.selectedSubCategories
    },
    selectedRecipeCategories(){
      if(this.$route.name == 'Recipe')
        return this.$store.getters.getThisRecipe.Categories.map(category => category.Name)
      else return []
    }
  }
}
</script>

<style lang="scss">
  .tags{
    background: #aacd9a4b;
    box-shadow: inset 0 0 4px rgba(0,0,0,0.3);
    transform: translate(0, -100%);
    position: absolute;
    top: 340px;
    text-align: center;
    padding: 5px 5px 10px;
    width: 100%;
    .tag{
      white-space: nowrap;
    }
  }
</style>